import ManipulatedOrdersTable from '../components/manipulated_orders/manipulated_orders_table.vue'
import EditManipulatedOrderFields from '../components/manipulated_orders/edit_manipulated_order_fields.vue'
import ShowManipulatedOrderFields from '../components/manipulated_orders/show_manipulated_order_fields.vue'

export default {
  components: {
    ManipulatedOrdersTable,
    EditManipulatedOrderFields,
    ShowManipulatedOrderFields
  },
  data: () => ({
  })
}